// Mock data for Project Soft Power

export const heroImages = [
  {
    url: 'https://images.unsplash.com/photo-1556484687-30636164638b',
    alt: 'Global Unity and Cooperation'
  },
  {
    url: 'https://images.unsplash.com/photo-1516146544193-b54a65682f16',
    alt: 'Cultural Expression'
  },
  {
    url: 'https://images.unsplash.com/photo-1498804103079-a6351b050096',
    alt: 'Global Cultural Exchange'
  },
  {
    url: 'https://images.unsplash.com/photo-1534030819-e584013b0531',
    alt: 'Diversity and Inclusion'
  },
  {
    url: 'https://images.pexels.com/photos/22669715/pexels-photo-22669715.jpeg',
    alt: 'Global Perspective'
  }
];

export const artsImages = [
  {
    url: 'https://images.unsplash.com/flagged/photo-1572392640988-ba48d1a74457',
    title: 'Classical Ceiling Art',
    description: 'Renaissance masterpieces adorning historic palaces',
    region: 'Europe'
  },
  {
    url: 'https://images.unsplash.com/photo-1554907984-15263bfd63bd',
    title: 'Museum Gallery',
    description: 'Curated collection of classical paintings',
    region: 'International'
  },
  {
    url: 'https://images.pexels.com/photos/2574476/pexels-photo-2574476.jpeg',
    title: 'Sculpture Gallery',
    description: 'Contemporary and classical sculptures',
    region: 'Global'
  },
  {
    url: 'https://images.unsplash.com/photo-1582561424760-0321d75e81fa',
    title: 'Maritime Heritage',
    description: '17th century Dutch maritime art',
    region: 'Europe'
  },
  {
    url: 'https://images.unsplash.com/photo-1579783900882-c0d3dad7b119',
    title: 'Classical Still Life',
    description: 'Vase of Flowers by Jan Davidsz de Heem',
    region: 'Netherlands'
  },
  {
    url: 'https://images.unsplash.com/photo-1653987255814-3b4c05832660',
    title: 'Art Experience',
    description: 'Engaging with masterpieces',
    region: 'Global'
  }
];

export const filmsImages = [
  {
    url: 'https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c',
    title: 'Cinema Experience',
    description: 'Audiences united through storytelling'
  },
  {
    url: 'https://images.unsplash.com/photo-1527979809431-ea3d5c0c01c9',
    title: 'Film Festival',
    description: 'Outdoor cinema bringing communities together'
  },
  {
    url: 'https://images.unsplash.com/photo-1576280314550-773c50583407',
    title: 'Cinematographer at Work',
    description: 'The art of visual storytelling'
  },
  {
    url: 'https://images.unsplash.com/photo-1619473667737-b3abeb860aa1',
    title: 'Professional Equipment',
    description: 'High-end cinema technology'
  },
  {
    url: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26',
    title: 'Heritage of Cinema',
    description: 'Vintage projection equipment'
  }
];

export const cultureImages = [
  {
    url: 'https://images.unsplash.com/photo-1724398915427-edc535c546fe',
    title: 'Roman Heritage',
    description: 'The Colosseum - A testament to ancient civilization',
    region: 'Europe'
  },
  {
    url: 'https://images.unsplash.com/photo-1769928614665-8c4b9b02a9e9',
    title: 'Theyyam Festival',
    description: 'Traditional ritual art form from Kerala',
    region: 'Asia'
  },
  {
    url: 'https://images.unsplash.com/photo-1637217632015-d1d00b77f327',
    title: 'Cultural Handicrafts',
    description: 'Traditional tea ceremony vessels',
    region: 'Asia'
  },
  {
    url: 'https://images.unsplash.com/photo-1763733593826-d51c270cc8b4',
    title: 'Indigenous Community',
    description: 'Nepali women in traditional attire',
    region: 'Asia'
  },
  {
    url: 'https://images.pexels.com/photos/34840277/pexels-photo-34840277.jpeg',
    title: 'Architectural Heritage',
    description: 'Contemporary cultural spaces',
    region: 'Global'
  },
  {
    url: 'https://images.pexels.com/photos/33607880/pexels-photo-33607880.jpeg',
    title: 'Cultural Architecture',
    description: 'Modern heritage preservation',
    region: 'Global'
  }
];

export const impactStats = [
  {
    number: '127',
    label: 'Partner Nations',
    icon: 'Globe'
  },
  {
    number: '2,400+',
    label: 'Cultural Projects',
    icon: 'Palette'
  },
  {
    number: '850+',
    label: 'Film Co-Productions',
    icon: 'Film'
  },
  {
    number: '15M+',
    label: 'Lives Impacted',
    icon: 'Users'
  }
];

export const missionPoints = [
  {
    title: 'Cultural Diplomacy',
    description: 'Building bridges between nations through arts, cinema, and shared heritage'
  },
  {
    title: 'Heritage Preservation',
    description: 'Protecting and celebrating indigenous cultures and endangered traditions'
  },
  {
    title: 'Creative Collaboration',
    description: 'Fostering international partnerships in arts, film production, and cultural exchange'
  },
  {
    title: 'Peace Through Culture',
    description: 'Promoting mutual understanding and global peace through creative expression'
  }
];

export const programs = [
  {
    title: 'Cultural Exchange',
    description: 'Artist residencies and international collaborations fostering creative dialogue across borders',
    icon: 'ArrowLeftRight'
  },
  {
    title: 'Film Co-Productions',
    description: 'Supporting cross-border cinema projects that tell universal human stories',
    icon: 'Film'
  },
  {
    title: 'Heritage Preservation',
    description: 'Documenting and protecting endangered cultural practices and traditions',
    icon: 'Landmark'
  },
  {
    title: 'Youth Leadership',
    description: 'Empowering next generation cultural ambassadors through education and mentorship',
    icon: 'Users'
  },
  {
    title: 'Digital Archives',
    description: 'Creating accessible repositories of global cultural heritage for future generations',
    icon: 'Database'
  },
  {
    title: 'Festival Network',
    description: 'Connecting international arts and film festivals to amplify cultural voices',
    icon: 'Calendar'
  }
];

export const teamMembers = [
  {
    name: 'Founder & Director',
    role: 'Visionary Leader',
    image: 'https://customer-assets.emergentagent.com/job_bb736b37-09cb-4465-9b20-ce9e662fa067/artifacts/vz3zs163_Copy%20of%20LEANDER%20LEE%20MARTY%20ON%20BOARD%20POSTER.png.PNG',
    bio: 'Leading international efforts in cultural diplomacy and strategic arts development'
  },
  {
    name: 'Dr. Sarah Chen',
    role: 'Director of Arts Programs',
    region: 'Asia Pacific',
    bio: 'Over 20 years experience in museum curation and international arts collaboration'
  },
  {
    name: 'Ambassador David Okonkwo',
    role: 'Director of Cultural Diplomacy',
    region: 'Africa & Middle East',
    bio: 'Former diplomat specializing in cultural exchange and international relations'
  },
  {
    name: 'Maria Rodriguez',
    role: 'Director of Film Programs',
    region: 'Americas',
    bio: 'Award-winning filmmaker and advocate for international cinema cooperation'
  },
  {
    name: 'Prof. Henrik Larsson',
    role: 'Director of Heritage Preservation',
    region: 'Europe',
    bio: 'Leading expert in UNESCO heritage sites and cultural conservation'
  }
];

export const testimonials = [
  {
    quote: 'Project Soft Power serves as a vital bridge between civilizations, nurturing peace through creative dialogue and shared heritage.',
    author: 'Dr. Amina Patel',
    role: 'UNESCO Cultural Ambassador'
  },
  {
    quote: 'Through arts and cinema, we discover our common humanity. This initiative is transforming how nations connect.',
    author: 'Jean-Claude Martin',
    role: 'Cannes Film Festival Director'
  },
  {
    quote: 'Cultural diplomacy is the most powerful tool for peace. Project Soft Power exemplifies this mission.',
    author: 'Ambassador Kenji Tanaka',
    role: 'Former UN Representative'
  }
];
